namespace $ {
	export type $easyreels_gql_failure = {
		message: string
		byFields: readonly { name: string; value: string }[]
	}

	export function $easyreels_gql_field_error(error: $easyreels_gql_failure | null, field: string) {
		const value = error?.byFields.find(item => item.name === field)?.value

		return value ? $easyreels_i18n_note_line($easyreels_i18n_server(value)) : ''
	}

	export function $easyreels_gql_form_error(error: $easyreels_gql_failure | null) {
		if (!error) return ''

		return error.byFields.length ? '' : $easyreels_i18n_note_line($easyreels_i18n_server(error.message))
	}
}
